module.exports = __webpack_public_path__ + "static/media/striped_bar_postlapAERO_hand.4537b14e.svg";